import styled from 'styled-components';
import { StockSliceStyled } from '../StockSliceStyled';
import { rem } from 'polished';

export const StockSliceStyledAC = styled(StockSliceStyled)`
    .offer-item > div {
        border: 1px solid ${({ theme }) => theme.colors.grey2};
    }

    .header {
        &-title {
            &-main {
                font-size: ${rem(30)};
                color: ${({ theme }) => theme.colors.grey5};
            }
            &-description {
                font-size: ${rem(18)};
                color: ${({ theme }) => theme.colors.grey5};
            }
        }
    }
`;
